<script setup>
import { useHttp } from "vutil";

defineProps(["charger"]);
const emit = defineEmits(["close", "learn"]);

const { busy, error, post } = useHttp(() => emit("learn"));
</script>

<template>
	<UiDialog :modal="busy" @close="$emit('close')">
		<h1>Tilordne ladebrikke</h1>
		<div>Slik kan du tilordne en ladebrikke til din brukerkonto:</div>
		<ol>
			<li>Klikk på &quot;Sett Ladebrikke&quot; knappen under.</li>
			<li>Kople til bilen og skann brikken innen 10 minutter.</li>
		</ol>
		<p>Denne brikken vil deretter kunne brukes for å autorisere dine fremtidige ladeøkter.</p>
		<div>Dersom du har fått ny brikke brukes samme prosedyre for å tilordne denne.</div>
		<form @submit.prevent="post(`/api/charger/${charger.id}/learn-rfid`)">
			<div class="error">{{ error }}</div>
			<button class="ui" :disabled="busy">Sett Ladebrikke</button>
		</form>
	</UiDialog>
</template>
